import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_types_of_inkind_benefits_does_the_fac_prov_select_all_tha'

export const dataPointDefinition = {
  retracedId: 'which_types_of_inkind_benefits_does_the_fac_prov_select_all_tha',
  name: 'Which types of in-kind benefits does the facility provide?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CHILD_CARE',
      text: 'Child Care',
      externalIds: [
        {
          id: 'wb-22--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-1f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'TRANSPORTATION',
      text: 'Transportation',
      externalIds: [
        {
          id: 'wb-22--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HOUSING',
      text: 'Housing',
      externalIds: [
        {
          id: 'wb-22--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FOOD',
      text: 'Food',
      externalIds: [
        {
          id: 'wb-22--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MEDICAL_SERVICES',
      text: 'Medical Services',
      externalIds: [
        {
          id: 'wb-22--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ENERGY_I_E_FUEL_COAL_ELECTRICITY_GAS_ETC_',
      text: 'Energy (i.e. fuel, coal, electricity, gas etc.)',
      externalIds: [
        {
          id: 'wb-22--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-6f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FOOTWEAR_CLOTHING',
      text: 'Footwear / Clothing',
      externalIds: [
        {
          id: 'wb-22--2-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'wb-22--2-7f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-22--2-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-22--2-8f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CHILD_CARE',
                'TRANSPORTATION',
                'HOUSING',
                'FOOD',
                'MEDICAL_SERVICES',
                'ENERGY_I_E_FUEL_COAL_ELECTRICITY_GAS_ETC_',
                'FOOTWEAR_CLOTHING',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-67',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9420,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
